
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asuransi-isi-rumah",
      function () {
        return require("private-next-pages/asuransi-isi-rumah.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asuransi-isi-rumah"])
      });
    }
  